import actionTypes from '../actionTypes/mostUsedToolset';

export default {
  setMarkType: (payload) => ({
    type: actionTypes.SET_MARKS,
    payload,
  }),

  setExpertTips: (params) => (dispatch) => {
    dispatch({
      type: actionTypes.SET_EXPERT_TIPS,
      payload: { ...params },
    });
  },
};
